export default __webpack_public_path__ + "static/media/404-page-not-found.7c803301.svg";